import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import { Link as ScrollLink } from 'react-scroll'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  AutocompleteSearch
} from '../../components'
import Styles from './HomeHero.css'


@CSSModules(Styles, {allowMultiple:true})
export default class HomeHero extends Component {
  render() {
    return (
      <section styleName='hero-panel'>
        <div styleName='hero-panel__overlay' />
        <ContainerDivs>
          <div styleName='hero-panel__content'>
            <h1 styleName='hero-panel__title'>
              Are you investing in a sustainable future?
            </h1>
            <p styleName='hero-panel__tagline'>
              Climate + social impact ratings for mutual funds & ETFs 
            </p>
            <div styleName='hero-panel__autocomplete-wrap'>
              <AutocompleteSearch />
            </div>
            <div styleName='hero-panel__link'>
              <Link
                to={config.routes.clean}
                title='See the full list'
              >
                See the full list<LinkIcon />
              </Link>
            </div>
            <p styleName='hero-panel__tagline'>
              See your employer's 401(k) scorecard
            </p>
            <div styleName='hero-panel__button'>
              <ScrollLink to='h-plans' spy title='401(k)s & other retirement plans' smooth offset={-50} duration={500}>
                <span>Retirement plans<LinkIcon faclass='fa-arrow-down'/></span>
              </ScrollLink>
            </div>
          </div>
        </ContainerDivs>
      </section>
    )
  }
}

